import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../stores/store';
import ListLayout from '../../../Generic/ListLayout';
import DataTable from '../../../Generic/DataTable';
import confirmDeleteDialog from '../../../Generic/confirmDeleteDialog';
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import useDeleteItem from '../../../../hooks/useDeleteItem';
import useFilterData from '../../../../hooks/useFilterData';
import useFetchData from '../../../../hooks/useFetchData';
import useLocalizedTextsMap from '../../../../hooks/useLocalizedTextsMap';
import { useSetMenu } from "../../../../hooks/useSetMenu";
import { createActiveColumn, createActionColumn, createGeneralColumn } from '../../../Generic/dataGridColumns';

const List = () => {
  const axiosPrivate = useAxiosPrivate();
  const { mainStore, platformHistoryStore } = useStore();
  const { t } = useTranslation();
  const localizedTextsMap = useLocalizedTextsMap();
  useSetMenu(mainStore.PlatformHistoryAdminMenuType, mainStore.PlatformHistoryAdminMenuNo);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  useFetchData(axiosPrivate, `/PlatformHistory`, platformHistoryStore);
  const filteredData = useFilterData(toJS(platformHistoryStore.platformHistory), searchQuery);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const deleteItem = useDeleteItem(axiosPrivate, '/PlatformHistory', platformHistoryStore.deleteItem);

  const remove = useCallback((id) => {
    confirmDeleteDialog(t, deleteItem, id);
  }, [deleteItem, t]);

  const cols = useMemo(() => [
    createGeneralColumn("eraOrder", "order", t, 80),
    createGeneralColumn("yearRange", "yearRange", t, 120),
    createGeneralColumn("phaseNameEN", "phase", t, 150),
    createGeneralColumn("titleEN", "title", t, 200),
    createActiveColumn(t),
    createActionColumn(t, "/Admin/PlatformHistory/Edit", remove),
  ].filter(Boolean), [t, remove]);

  useEffect(() => {
    setColumns(cols);
    // eslint-disable-next-line
  }, [t]);

  return (
    <>
      <ListLayout
        title={t("platformHistoryListTitle") || "Platform History"}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("searchPlaceholder")}
        addButtonLink="/Admin/PlatformHistory/Add"
        addButtonTitle={t("add")}
      >
        <DataTable
          rows={filteredData}
          columns={columns}
          pageSize={pageSize}
          setPageSize={setPageSize}
          localeTextsMap={localizedTextsMap}
        />
      </ListLayout>
    </>
  );
};

export default observer(List);
